module.exports = __webpack_public_path__ + "img/deco-1.7f30108e.svg";